import { reduxKey } from './constants';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export var getGalleries = function (state) { return getState(state).galleries; };
export var getGalleryDeviations = function (state) {
    return getState(state).galleryContents
        ? getState(state).galleryContents.deviations
        : [];
};
export var getGalleryDeviationsTotal = function (state) {
    return getState(state).galleryContents ? getState(state).galleryContents.total : 0;
};
export var getGalleryId = function (state) { return getState(state).galleryId; };
export var getHasWixAccount = function (state) { return getState(state).hasWixAccount; };
export var getFlowState = function (state) { return getState(state).flowState; };
export var getPreviewUrl = function (state) { return getState(state).previewUrl; };
export var getEditAndPreviewUrl = function (state) { return getState(state).editAndPreviewUrl; };
export var getShouldDisplayDiscardModal = function (state) {
    return getState(state).shouldDisplayDiscardModal;
};
export var getInitialFormState = function (state) { return getState(state).initialFormState; };
//# sourceMappingURL=selectors.js.map